<template>
    <div class="multity-import-pic">
        <TitleBaseBox :title="title" :noButton="true" class="model-wrap" @close="close">
            <div class="model-content">
                <PictureCard
                    v-show="!howLoading"
                    v-for="(item, idx) in importImgs"
                    :key="idx"
                    :data="item"
                    @nameChange="nameChange"
                    @tagsChange="tagsChange"
                    @deleteImage="deleteImage"
                />
                <div v-show="howLoading" class="image-loading">{{ loadingText }}</div>
            </div>
            <div class="img-model-bottom">
                <div class="import-img-total">
                    {{ $t("zhiji.materialLibrary.addTotal") + imgTotal + $t("zhiji.materialLibrary.picNum") }}
                </div>
                <div class="btn-box">
                    <RoundButton :text="cancelLabel" @btnClick="cancelClick" class="cancel-btn"></RoundButton>
                    <RoundButton :text="confirmLabel" @btnClick="confirmClick" class="confirm-btn"></RoundButton>
                </div>
            </div>
        </TitleBaseBox>
    </div>
</template>

<script>
import { ParamError } from "@/views/zhiji/js/common/errors.js";
import TitleBaseBox from "@/views/zhiji/bComponents/TitleBaseBox";
import RoundButton from "@/views/zhiji/bComponents/buttons/RoundButton";
import PictureCard from "./PictureCard";

export default {
    name: "MultImportPictureModel",
    props: ["data"],
    components: {
        TitleBaseBox,
        RoundButton,
        PictureCard
    },
    data() {
        return {
            imgTotal: 0,
            importImgs: []
        };
    },
    computed: {
        howLoading() {
            return this.imgTotal > 0 ? false : true;
        },
        title() {
            return this.$t("zhiji.materialLibrary.addPictures");
        },
        confirmLabel() {
            return this.$t("zhiji.common.confirm");
        },
        cancelLabel() {
            return this.$t("zhiji.common.cancel");
        },
        loadingText() {
            return this.$t("zhiji.materialLibrary.picLoading");
        }
    },
    mounted() {
        this.importMulitImages();
    },
    methods: {
        getStorePorp(propName) {
            return this.$store.state.materialLibraryPage[propName];
        },
        nameChange(updateData) {
            this.updateImagesData(updateData, "name");
        },
        tagsChange(updateData) {
            this.updateImagesData(updateData, "tags");
        },
        deleteImage(deleteData) {
            let newData = [];
            this.importImgs.forEach(item => {
                if (item.uId !== deleteData.uId) {
                    newData.push(item);
                }
            });
            this.importImgs = newData;
            this.imgTotal = this.importImgs.length;
            if (this.imgTotal == 0) {
                this.close();
            }
        },
        updateImagesData(updateData, type) {
            this.importImgs.forEach(item => {
                if (item.uId === updateData.data.uId) {
                    type === "name" ? (item.name = updateData.newData) : (item.imgTags = updateData.newData);
                }
            });
        },
        importMulitImages() {
            this.zhiji
                .requestByServiceName("multiUploadImage", this.data.formData)
                .then(ret => {
                    this.imgTotal = ret.length;
                    this.importImgs = ret && ret.map((item) => ({
                            ...item,
                            imgTags: this.data.tagIds,}))
                }).catch(err => {
                    throw err;
                });
        },
        close() {
            this.$emit("closeModal");
        },
        cancelClick() {
            this.close();
        },
        confirmClick() {
            let checkData = this.importImgs;
            new Promise(function(resolve) {
                checkImagesData(checkData);
                resolve();
            })
                .then(() => {
                    this.saveMultiPicture();
                })
                .catch(err => {
                    if (err.errorType == "ParamError" || err.errorType == "ServerRespError") {
                        this.$store.dispatch("zhiji/showModal", {
                            type: "MessageModal",
                            data: {
                                type: "error",
                                message: err.message
                            }
                        });
                    }
                });
        },
        saveMultiPicture() {
            this.zhiji.requestByServiceName("multiSaveVlinkImage", this.importImgs).then(result => {
                if (result.errCode) {
                    this.successTips(result.errMessage);
                    return;
                }
                this.data.confirm && this.data.confirm(result);
                this.updatePictureList();
                this.close();
            });
        },
        successTips(tipText) {
            this.$store.dispatch("zhiji/showModal", {
                type: "MessageModal",
                data: {
                    type: "tip",
                    message: tipText,
                    cancel: () => {},
                    confirm: () => {}
                }
            });
        },
        updatePictureList() {
            this.$store.dispatch("zhiji/queryPictureList", {
                page: 1,
                size: 15
            });
        }
    }
};

// 校验攻略参数
function checkImagesData(data) {
    data.forEach(item => {
        if (!item.name) {
            throw new ParamError("图片名称不能为空！");
        }

        if (!item.imgTags) {
            throw new ParamError("图片标签不能为空！");
        }
    });
}
</script>

<style lang="less" scoped>
.multity-import-pic {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(65, 71, 94, 0.4);
    display: flex;
    justify-content: center;
    align-items: center;
    .model-wrap {
        position: relative;
        .model-content {
            font-size: 12px;
            box-sizing: border-box;
            width: 1050px;
            margin-top: -8px;
            min-height: 450px;
            max-height: 550px;
            overflow-y: auto;
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            margin-bottom: 74px;
            .image-loading {
                width: 100%;
                text-align: center;
            }
        }
    }
    .img-model-bottom {
        width: 100%;
        padding: 20px 0;
        background: #fafbfd;
        border-top: 1px solid #d8e4f0;
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: absolute;
        left: 0;
        bottom: 0;
        .import-img-total {
            font-size: 14px;
            margin-left: 20px;
        }
    }
}
</style>
